/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewEncapsulation, ViewChild} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule,PaginatorModule, DropdownModule, ConfirmDialogModule, ConfirmationService} from 'primeng/primeng';
import {Router, RouterModule} from "@angular/router";
import {BrowserModule} from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import {MamAdminService} from '../../service/mam_service.component';
import {Device} from '../../model/device';
import {DeviceResource} from '../../model/deviceresource';
import {ControlLog} from '../../model/controllog';
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {UserGroupTreeModule} from "../../component/user_tree.component";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {AttributeGroupTreeModule} from "../../component/attribute-group-tree/attribute-group-tree.component";
import {SelectItem} from "primeng/components/common/api";
import {TranslateServiceForm} from "../../translate/translate.service";
import {SearchModule} from "../../component/search.component";
import {DatexPipe} from "../../pipe/datex.pipe";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe"; // ADD THIS

@Component({

    selector: 'remote-management',
    templateUrl: 'remote_management.html',
    encapsulation: ViewEncapsulation.None
})
export class RemoteManagementComponent implements OnInit {
    private device_list: Device[] = [];
    private selectDeviceList: Device[] = [];
    private deviceInformation: any;
    private deviceDetailInformation: any;
    private deviceResourceList: DeviceResource[] = [];
    private log_list: ControlLog[] = [];

    remote_group_type: SelectItem[];

    logList: any;
    beforeIsTrue: boolean = true;
    clickIsTrue: boolean = true;

    lostContent: boolean = false;

    remoteContent: boolean = false;
    selectedRadio: string;

    backupContent: boolean = false;

    selected_group: any;
    groupDeviceList: any;
    totalRecord: number = 0;
    select_type: number;

    selectedCompany: any;

    dateIsTrue: boolean;

    searchIDs: SelectItem[];
    searchIsTrue: boolean;
    searchText: string;
    searchId: string;
    sDate: string;
    eDate: string;
    pageMax: number = 10;
    resetIsTrue: any = "true";


    //도난 분실
    lostDeviceState : any = "";
    lostPhoneNumberIsTrue : boolean;
    lostMessageIsTrue : boolean;
    lostPhoneNumber : string;
    lostMessage : string;
    lostActionImage : any;
    lostStatus : string;
    @ViewChild('lostAccordion') lostAccordion : any;
    @ViewChild('remoteAccordion') remoteAccordion : any;

    //복구
    backUpDateTime : any;
    restoreDateTime : any;
    private translate: TranslateServiceForm;
    @ViewChild('backupAccordion') backupAccordion : any;

    constructor(private service: MamAdminService, private _translate: TranslateServiceForm, private confirmationService: ConfirmationService, private logger : Logger) {
        this.translate = _translate;
    }
    ngOnInit() {

        this.remote_group_type = [];
        this.remote_group_type.push({label: this.translate.instant('LANG_TargetDevice'), value: 0});
        this.remote_group_type.push({label: this.translate.instant('LANG_TargetUser'), value: 1});
        this.remote_group_type.push({label: this.translate.instant('LANG_group'), value: 2});

        this.searchIDs = [];
        this.searchIDs.push({label: '---------------', value: 'all'});
        this.searchIDs.push({label: this._translate.instant('LANG_USR_user'), value: 'name'});
        //this.searchIDs.push({label: this._translate.instant('LANG_MemberNum'), value: 'membernum'});
        this.searchIDs.push({label: this._translate.instant('LANG_PhoneNumber'), value: 'mobilenumber'});
        //this.searchIDs.push({label: this._translate.instant('IsRegistered'), value: 'isRegistered'});
    }

    // ----------------- SERVICE -----------------------------------
    getDeviceBaseInfo(deviceId: number) {
        this.service.getDeviceBaseInfo(deviceId).subscribe(
            value => {
                this.device_list = value;

                this.logger.debug("-- device_list2 :", this.device_list);
                this.logger.debug("-- device_list :", value);
            },
            error => {
                this.logger.error("-- error : " + error);
                this.logger.error("-- error : " + error.toString());
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }

    getDeviceResource(deviceId: number) {
        this.service.getDeviceResource(deviceId).subscribe(
            value => {
                let detailItem = [];
                for (let i = 0; i < 18; i++) {
                    let obj = {key: "", itemValue: ""};
                    if (i <= 9) {
                        obj.key = "100" + i;
                    } else {
                        obj.key = "200" + (i - 9);
                    }
                    detailItem.push(obj);
                }


                //this.deviceResourceList = value;
                if (value.length > 0) {
                    this.deviceDetailInformation = value;
                    this.deviceDetailInformation.forEach(item => {
                        detailItem.forEach(detail => {
                            if (item.itemKey == detail.key) {
                                detail.itemValue = item.itemValue;
                            }
                        })
                    });
                }


                this.deviceDetailInformation = detailItem;
                //this.logger.debug("detailItem",detailItem);


                //this.logger.debug("-- device_resource_list :", this.deviceResourceList[0]);
                //this.logger.debug("deviceDetailInformation : ",this.deviceDetailInformation);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {

            }
        )
    }


    getLostDeviceInfo(deviceId: number) {
        this.service.getLostDeviceInfo(deviceId).subscribe(
            value => {
                //this.lostDeviceState = value;
                if(value.lost == 'LOST' || value.lost == 'LOST_ING'){
                    if(value.lost=='LOST'){ this.lostDeviceState = this.translate.instant('LANG_REMOTE_LOST_REPORT_MESSAGE')+"\n"; }
                    else{this.lostDeviceState=this.translate.instant('LANG_REMOTE_LOST_ING_REPORT_MESSAGE')+"\n";}

                    this.lostDeviceState += value.isLostTime;

                    this.lostActionImage = "resource/image/btn_lost_clear.png";
                    this.lostPhoneNumberIsTrue = false;
                    this.lostMessageIsTrue = false;

                    this.lostStatus = "lost";
                }else if(value.lost == 'NOT_LOST' || value.lost == 'NOT_LOST_ING'){
                    if(value.lost == "NOT_LOST"){ this.lostDeviceState=this.translate.instant('LANG_REMOTE_LOST_NOT_REPORT_MESSAGE');}
                    else{ this.lostDeviceState=this.translate.instant('LANG_REMOTE_LOST_NOT_ING_REPORT_MESSAGE');}

                    this.lostActionImage = "resource/image/btn_lost_regi.png";

                    this.lostPhoneNumberIsTrue = true;
                    this.lostMessageIsTrue = true;
                    this.lostStatus = "find";
                }

                this.logger.debug("-- lostDevice_state :", value);
                this.logger.debug("로스트 상태",this.lostDeviceState);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }

    getBackupState(deviceId: number) {
        this.service.getBackupState(deviceId).subscribe(
            value => {
                let lost_state = value;
                this.backUpDateTime = value.backUpDateTime;
                this.restoreDateTime = value.restoreDateTime;
                this.logger.debug("-- 백업상태 :", value);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }

    //도난분실 신고/해제 실행
    getLostDeviceCommpandAct(commandType: string, deviceId: number) {
        this.service.getLostDeviceCommpandAct(commandType, deviceId, this.lostPhoneNumber, this.lostMessage).subscribe(
            value => {
                let lost_state = value;
                let item = [];
                item.push(deviceId);
                this.logger.debug("-- 도난분실 신고/해제 실행 다음 :", value);
                let command = "LOST";
                if(commandType == "find"){command="FOUND"};
				if(this.deviceInformation.deviceTypeId.osType=="IOS") {
					if(command=="LOST") {this.IosSupervisePushByDevice(command, this.lostPhoneNumber+"_"+this.lostMessage , item);}
               		else if(command="FOUND") this.IosSupervisePushByDevice(command,'',item);
				} else {
					if(command=="LOST") {this.RemotePushByDevice(command, this.lostPhoneNumber+"_"+this.lostMessage , item);}
               		else if(command="FOUND") this.RemotePushByDevice(command,'',item);
				}
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }

	getIosLostDeviceCommpandAct(commandType: string, deviceId: number) {
        this.service.getLostDeviceCommpandAct(commandType, deviceId, this.lostPhoneNumber, this.lostMessage).subscribe(
            value => {
                let lost_state = value;
                let item = [];
                item.push(deviceId);
                this.logger.debug("-- 도난분실 신고/해제 실행 다음 :", value);
                let command = "LOST";
                if(commandType == "find"){command="FOUND"};

                if(command=="LOST") {this.IosSupervisePushByDevice(command, this.lostPhoneNumber+"_"+this.lostMessage , item);}
                else if(command="FOUND") this.IosSupervisePushByDevice(command,'',item);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }

    getControlLogForDevice(page: number, max: number, deviceId: number) {
        this.service.getControlLogForDevice(page, max, deviceId).subscribe(
            value => {
                this.logList = value.rows;
                let log_list = value;
                if (this.logList && this.logList.length > 0) {
                    for (var i = 0; i < this.logList.length; i++) {
                        this.logList[i].message = this.translate.instant(this.logList[i].message);
                        this.logList[i].status = this.translate.instant(this.logList[i].status);
                    }
                }
                this.logger.debug("-- log_list :", value);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }

    getGroupDevice(groupId: number, page: number, size: number) {
        this.service.getGroupDevice(groupId, page, size).subscribe(
            value => {
                this.groupDeviceList = value.content;
                this.totalRecord = value.totalElements;
                this.logger.debug("-- groupDeviceList : ", this.groupDeviceList);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
            }
        )
    }

    RemotePushByDevice(command: string, value: string, device_ids: any) {
        this.service.remotePushByDevice(command, value, device_ids).subscribe(
            value => {
                let result = value;
                this.getLostDeviceInfo(this.deviceInformation.id);
                this.getBackupState(this.deviceInformation.id);
                this.logger.debug("-- RemotePushByDevice result : ", result);
                alert(this.translate.instant('Message_Alert_Success'));
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
            }
        )
    }

	IosSupervisePushByDevice(command: string, value: string, device_ids: any) {
        this.service.iosSupervisePushByDevice(command, value, device_ids).subscribe(
            value => {
                let result = value;
                this.getLostDeviceInfo(this.deviceInformation.id);
                /*this.getBackupState(this.deviceInformation.id);*/
                this.logger.debug("-- IosSupervisePushByDevice result : ", result);
                alert(this.translate.instant('Message_Alert_Success'));
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
            }
        )
    }

    getGroupDeviceBySearch(groupId:number,page:number,size:number, search:string, field:string){
        this.service.getGroupDeviceBySearch(groupId,page,size,search,field).subscribe(
            value => {
                this.groupDeviceList = value.content;
                this.totalRecord = value.totalElements;
                this.logger.debug("-- getGroupDeviceBySearch : ",this.groupDeviceList);
            },
            error => {
                this.logger.error("-- error : " + error);
            },
            () => {
                this.logger.info("-- complate : ");
            }
        )
    }
    // -------------------------------------------------------------------
    sendComment(event) {
        this.logger.debug("command value :", this.selectedRadio);
        let device_ids: number[] = [];
        if (this.selectDeviceList.length > 0) {
            this.selectDeviceList.forEach(device => {
                device_ids.push(device.id);
            });

            this.confirmationService.confirm({
                message: this.translate.instant('Message_Want_Run_it'),
                header: this.translate.instant('LANG_Remote_Control_Execution'),
                icon: 'fa',
                accept: () => {
                    this.logger.debug("device_ids :", device_ids);
					if(this.deviceInformation.deviceTypeId.osType=="IOS") {
						if (this.selectedRadio.indexOf('_') == -1){
	                        this.IosSupervisePushByDevice(this.selectedRadio, '', device_ids);
	                    } else if(this.selectedRadio == "POLICY_ON" || this.selectedRadio == "POLICY_OFF" || this.selectedRadio == "RM_1" || this.selectedRadio == "RM_2") {
	                        this.IosSupervisePushByDevice(this.selectedRadio, '', device_ids);
	                    } else {
	                        let command = this.selectedRadio.split("_");
	                        this.logger.debug(command);
	                        this.IosSupervisePushByDevice(command[0], command[1], device_ids);
	                    }
					} else {
						if (this.selectedRadio.indexOf('_') == -1){
	                        this.RemotePushByDevice(this.selectedRadio, '', device_ids);
	                    } else if(this.selectedRadio == "POLICY_ON" || this.selectedRadio == "POLICY_OFF" || this.selectedRadio == "RM_1" || this.selectedRadio == "RM_2") {
	                        this.RemotePushByDevice(this.selectedRadio, '', device_ids);
	                    } else {
	                        let command = this.selectedRadio.split("_");
	                        this.logger.debug(command);
	                        this.RemotePushByDevice(command[0], command[1], device_ids);
	                    }
					}
                    

                }
            });

        } else {
            alert(this.translate.instant('Message_Select_Device'));
        }

    }

    lostAction(event) {
        this.logger.debug("==> lostClick : ");
        if (this.selectDeviceList.length == 1) {
            let item =[];
            item.push(this.selectDeviceList[0].id);
            let message ="";
            let command = "";
            if(this.lostStatus == "lost"){
                message = this.translate.instant('LANG_REMOTE_LOST_CLEAR');
                command = "find";
            }else{
                message = this.translate.instant('LANG_REMOTE_LOST');
                command = "lost";
            }
            this.confirmationService.confirm({
                message: message,
                header: this.translate.instant('LANG_Lost/Stolen'),
                icon: 'fa',
                accept: () => {
                    this.getLostDeviceCommpandAct(command,this.selectDeviceList[0].id);
                    //if(command=="LOST") {this.RemotePushByDevice(command, this.lostPhoneNumber+"_"+this.lostMessage , item);}
                    //else if(command="FOUND") this.RemotePushByDevice(command,'',item);
                }
            });

        }
        else {
            alert(this.translate.instant('Message_Select_One_Device'));
        }

    }

    backUpAndRestoreRemote(name){
        let command = "";
        let message = "";
        if(name =="backUp"){command="BACKUP"; message=this.translate.instant('LANG_Want_BackUp');}
        else if(name =="restore"){command="RESTORE"; message = this.translate.instant('LANG_Want_Restore');}

        if (this.selectDeviceList.length == 1) {
            let item =[];
            item.push(this.selectDeviceList[0].id);

            this.confirmationService.confirm({
                message: message,
                header: this.translate.instant('LANG_Backup/Recovery'),
                icon: 'fa',
                accept: () => {
                    this.RemotePushByDevice(command,'',item);

                }
            });

        }
        else {
            alert(this.translate.instant('Message_Select_One_Device'));
        }
    }

    lostClick(event) {
        if(this.selectDeviceList.length ==1){
            this.lostContent = true;
            this.remoteContent = false;
            this.backupContent = false;
            this.getLostDeviceInfo(this.deviceInformation.id);

        }else{
            alert(this.translate.instant('Message_Select_One_Device'));
        }
    }

    remoteClick(event) {
        this.lostContent = false;
        this.remoteContent = true;
        this.backupContent = false;
    }

    backupClick(event) {
        if(this.selectDeviceList.length ==1){
            this.lostContent = false;
            this.remoteContent = false;
            this.backupContent = true;
            this.getBackupState(this.deviceInformation.id);
        }else{
            alert(this.translate.instant('Message_Select_One_Device'));
        }
    }

    onGroupSelect(event) {
        this.logger.debug("selected group : ", event);
        this.selected_group = event;
        this.resetIsTrue = "true"+event.id;
        this.selectDeviceList = [];
        this.getGroupDevice(event.id, 0, this.pageMax);
    }

    onRowSelect(event) {
        this.logger.debug("select data", event.data);
        this.beforeIsTrue = false;
        this.deviceInformation = event.data;

        if(this.selectDeviceList.length ==1){
            this.getDeviceResource(this.deviceInformation.id);
            this.getControlLogForDevice(1, 10, this.deviceInformation.id);
            //this.getLostDeviceInfo(this.deviceInformation.id);
            //this.getBackupState(this.deviceInformation.id);
        }
        //this.logger.debug("체크박스로 변경 선택", this.selectDeviceList);
    }

    onRowUnSelect(event){
        if(this.selectDeviceList.length ==1){
            this.getDeviceResource(this.selectDeviceList[0].id);
            this.getControlLogForDevice(1, 10, this.selectDeviceList[0].id);
            this.getLostDeviceInfo(this.selectDeviceList[0].id);
            this.getBackupState(this.selectDeviceList[0].id);
        }

    }


    onSelectedCompany(company) {
        this.selectedCompany = company;
        this.selectDeviceList = [];
        this.logger.debug("combo - select :", this.selectedCompany);
    }

    getSearchModel(event) {
        this.logger.debug("event : ", event);
        this.searchIsTrue = event.searchIsTrue;
        this.searchText = event.searchText;
        this.sDate = event.sDate;
        this.eDate = event.eDate;
        this.searchId = event.searchId;

        if (this.searchId == "all") {
            this.searchIsTrue = false;
            this.getGroupDevice(this.selected_group.id, event.page, this.pageMax);
        } else {
            this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
        }

        //this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
    }

    paginate(event) {
        this.pageMax = event.rows;
        if (this.searchIsTrue) {
            this.getGroupDeviceBySearch(this.selected_group.id, event.page, this.pageMax, this.searchText, this.searchId);
        } else {

            //this.getDeviceCondition(event.page + 1,this.pageMax,'2016-12-12','2017-02-02',"","","");
            this.getGroupDevice(this.selected_group.id, event.page, this.pageMax);
        }

    }

    backUpAndRestoreRefresh(event){
        this.getBackupState(this.deviceInformation.id);
    }

    lostChange(event){
        if(this.selectDeviceList.length ==1){
            this.getLostDeviceInfo(this.deviceInformation.id);
            if(this.lostContent == false){
                this.lostAccordion.nativeElement.className = 'icon01 accordion-active';
                this.remoteAccordion.nativeElement.className = 'icon02';
                this.remoteContent = false;
                this.backupAccordion.nativeElement.className = 'icon03';
                this.backupContent = false;
            }else
                this.lostAccordion.nativeElement.className = 'icon01';

            this.lostContent = !this.lostContent;
        }else{
            alert(this.translate.instant('Message_Select_One_Device'));
        }


    }

    remoteChange(event){
        if(this.selectDeviceList.length>0){
            if(this.remoteContent == false){
                this.remoteAccordion.nativeElement.className = 'icon02 accordion-active';
                this.lostAccordion.nativeElement.className = 'icon01';
                this.lostContent = false;
                this.backupAccordion.nativeElement.className = 'icon03';
                this.backupContent = false;
            }else
                this.remoteAccordion.nativeElement.className = 'icon02';

            this.remoteContent = !this.remoteContent;
        }else{
            alert(this.translate.instant('Message_Select_One_Or_More_Devices'));
        }

    }

    backupChange(event){
        if(this.selectDeviceList.length ==1){
            this.getBackupState(this.deviceInformation.id);
            if(this.backupContent == false){
                this.backupAccordion.nativeElement.className = 'icon03 accordion-active';
                this.lostAccordion.nativeElement.className = 'icon01';
                this.lostContent = false;
                this.remoteAccordion.nativeElement.className = 'icon02';
                this.remoteContent = false;
            }else
                this.backupAccordion.nativeElement.className = 'icon03';

            this.backupContent = !this.backupContent;
        }else{
            alert(this.translate.instant('Message_Select_One_Device'));
        }

    }

}

@NgModule({
    imports: [CommonModule, FormsModule, DataTableModule, TabViewModule, PanelModule, BrowserModule, HttpModule, RouterModule, OverlayPanelModule, ButtonModule, UserGroupTreeModule, PaginatorModule, AttributeGroupTreeModule, CompanyDropDownListModule, DropdownModule, SearchModule, ConfirmDialogModule, MainPipeMoudle, TranslatePipeMoudle],
    exports: [RemoteManagementComponent],
    declarations: [RemoteManagementComponent],
    providers: [MamAdminService, ConfirmationService],
})
export class RemoteManagementModule {
}



// WEBPACK FOOTER //
// ./src/app/page/device/remote_management.ts